import React from 'react';
import { useTranslation } from "react-i18next";
import ActionsDropdown from "../../common/ActionsDropdown";
import ActiveIndicator from "../../common/ActiveIndicator";

const CurrencyListItem = ({ index, item, lang, isRTL, editHandler, setSelectedItemId, setDeleteModalOpen }) => {
  const { t } = useTranslation("global");
  const currencyName = lang === 'ar' ? item.name_ar?.trim() : item.name_en?.trim();
  
  return (
    <div className='flex gap-2 px-3 py-1 border-t justify-between items-center text-xs text-gray-500'>
      <div className='w-16 text-center'>{index + 1}</div>
      <div className='flex-1'>{currencyName}</div>
      <div className='w-36 text-center'>{item.currency_code}</div>
      <div className='w-36 text-center'>{item.currency_rate}</div>
      <div className='w-36 text-center'>
        <div className='w-36 flex justify-center items-center'>
          <ActiveIndicator active={item.is_active === true || item.is_active === 'true'} />
        </div>
      </div>
      <div className='w-36 text-center'>
        <ActionsDropdown
          isRTL={isRTL}
          onEdit={() => editHandler(item.id)}
          onDelete={() => {
            setSelectedItemId(item.id);
            setDeleteModalOpen(true);
          }}
          itemId={item.id}
          editText={t('common.edit', 'تعديل')}
          deleteText={t('common.delete', 'حذف')}
        />
      </div>
    </div>
  );
};

export default CurrencyListItem;
